"use client";

import { Box, Container, Typography, Button, Fade } from "@mui/material";
import Grid from "@mui/material/Grid";
import { useEffect, useState } from "react";
import HomeIcon from "@mui/icons-material/Home";
import { useTheme } from "@mui/material/styles";
import PageContainer from "@/app/components/ui-components/PageContainer";
import { useRouter } from "next/navigation";

const NotFound = () => {
  const router = useRouter();
  const theme = useTheme();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Prevent default browser styles
    document.body.style.padding = "0";
    document.body.style.margin = "0";

    // Import the fonts
    const link = document.createElement("link");
    link.href =
      "https://fonts.googleapis.com/css?family=Cabin:400,700|Montserrat:900";
    link.rel = "stylesheet";
    document.head.appendChild(link);

    // Trigger fade-in
    setVisible(true);

    return () => {
      document.head.removeChild(link);
    };
  }, []);

  return (
    <PageContainer title="Meex" description="Oops! Page not found.">
      <Fade in={visible} timeout={1000}>
        <Grid
          container
          sx={{
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: theme.palette.background.default,
            minHeight: "100vh",
            p: 2
          }}>
          <Box>
            <Typography
              sx={{
                fontWeight: 900,
                letterSpacing: { xs: "-20px", md: "-65px" },
                m: 0,
                p: 0,
                lineHeight: 1,
                fontSize: { xs: "180px", sm: "250px", md: "360px" },
                textShadow: `10px 10px 0px ${theme.palette.background.default}, -4px -4px 0px ${theme.palette.background.default}`,
                textAlign: "center",
                fontFamily: "Montserrat, sans-serif"
              }}>
              <span
                style={{
                  textShadow: `10px 10px 0px ${theme.palette.background.default}, -4px -4px 0px ${theme.palette.background.default}`,
                }}
              >
                4
              </span>
              <span
                style={{
                  textShadow: `10px 10px 0px ${theme.palette.background.default}, -4px -4px 0px ${theme.palette.background.default}`,
                }}
              >
                0
              </span>
              <span
                style={{
                  textShadow: `10px 10px 0px ${theme.palette.background.default}, -4px -4px 0px ${theme.palette.background.default}`,
                }}
              >
                4
              </span>
            </Typography>
            <Typography
              variant="h6"
              sx={{
                lineHeight: 1.5,
                fontSize: { xs: "1rem", sm: "1.3rem" },
                fontWeight: 200,
                mt: { xs: 2, md: -2 },
                mb: { xs: 2, md: 3 }
              }}>
              The page you are looking for might have been removed had its name
              changed or <br />
              is temporarily unavailable.
            </Typography>
            <Button
              variant="outlined"
              size="1.25rem"
              onClick={() => router.push("/")}
              disableElevation
              startIcon={<HomeIcon />}
              sx={{
                borderRadius: "50px",
                padding: "0.8rem 3.5rem",
                border: "2px solid",
                transition: "background 0.3s, transform 0.3s",
                alignSelf: "center",
                "&:hover": {
                  transform: "scale(1.05)",
                  borderColor: theme.palette.primary.main,
                },
              }}
            >
              Go Back to Dashboard
            </Button>
          </Box>
        </Grid>
      </Fade>
    </PageContainer>
  );
};

export default NotFound;
